import { render } from "./MaterialRequests.vue?vue&type=template&id=5871fc44&scoped=true"
import script from "./MaterialRequests.vue?vue&type=script&lang=js"
export * from "./MaterialRequests.vue?vue&type=script&lang=js"

import "./MaterialRequests.vue?vue&type=style&index=0&id=5871fc44&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5871fc44"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QBtn,QTr,QIcon,QTooltip});
